import React from "react"
import LinkArrow from "../../svg/new/LinkArrow"

const FormButtonRed = ({ btnText, customClass, onClick, disable }) => {
  return (
    <button
      disabled={disable}
      className={`link_btn ${customClass}`}
      type="submit"
      onClick={onClick}
    >
      <div
        style={{
          position: "relative",
          zIndex: "11",
          fontFamily: " var(--Satoshi)",
        }}
      >
        {btnText}
      </div>
      <i>
        {" "}
        <LinkArrow />{" "}
      </i>
    </button>
  )
}

export default FormButtonRed
